import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { ONDERZOEKEN, BRONNEN } from "@/data/onderbouwing";

const ease = [0.22, 1, 0.36, 1];
const HOME_KEYS = ["cbs", "scp", "amsterdam"];
const ACCENT = { cbs: "#97B79D", scp: "#F0B98D", amsterdam: "#E06B3F" };

function Kaart({ o, i }) {
  const bron = BRONNEN[o.bronnen[0]];
  return (
    <motion.article
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-10%" }}
      transition={{ duration: 0.8, delay: i * 0.12, ease }}
      data-testid={`home-onderzoek-kaart-${o.k}`}
      className="relative flex flex-col rounded-[28px] bg-white border border-ll-ink/10 p-8 sm:p-10 overflow-hidden"
    >
      <span className="absolute top-0 left-0 h-1.5 w-full" style={{ background: ACCENT[o.k] }} />
      <div className="flex items-center justify-between">
        <p className="text-[10px] uppercase tracking-[0.35em] text-ll-navy/60">{o.org}</p>
        <span className="chapter-num text-sm text-ll-navy/40">{o.n}</span>
      </div>
      <p className="mt-8 chapter-num text-5xl sm:text-6xl leading-none text-ll-ink">{o.cijfer}</p>
      <p className="mt-4 text-sm text-ll-navy/75 leading-relaxed">{o.cijferLabel}{o.extra ? `, ${o.extra}` : ""}.</p>
      <p className="mt-8 pt-6 border-t border-ll-ink/10 font-heading italic text-xl leading-snug text-ll-ink flex-1">{o.kaart}</p>
      <a
        href={bron.url}
        target="_blank"
        rel="noreferrer"
        data-testid={`home-onderzoek-bron-${o.k}`}
        className="mt-6 inline-flex items-center gap-1.5 text-xs text-ll-navy/60 hover:text-ll-coral transition-colors"
      >
        Bron: {o.org} <ArrowUpRight size={12} />
      </a>
    </motion.article>
  );
}

export default function OnderzoekKaarten() {
  const items = ONDERZOEKEN.filter((o) => HOME_KEYS.includes(o.k));
  return (
    <section className="py-24 sm:py-32 bg-ll-mist relative overflow-hidden" data-testid="home-onderzoek">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16">
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, ease }} className="max-w-3xl">
          <p className="text-[10px] uppercase tracking-[0.35em] text-ll-coral">Onderzoek</p>
          <h2 className="mt-6 font-heading font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
            Wat onafhankelijk onderzoek <span className="italic">ons laat zien</span>
          </h2>
        </motion.div>
        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5">
          {items.map((o, i) => <Kaart key={o.k} o={o} i={i} />)}
        </div>
        <div className="mt-12 grid grid-cols-1 lg:grid-cols-12 gap-6 items-end">
          <p className="lg:col-span-8 text-sm text-ll-navy/70 leading-relaxed max-w-2xl" data-testid="home-onderzoek-nuance">
            Een nuance: dit zijn landelijke en Amsterdamse cijfers. Ze laten patronen zien, maar bewijzen niet dat er in iedere gemeente een tekort is.
            Het Amsterdamse onderzoek gaat over nieuwe instromers, en een niet-geregistreerd instrument betekent niet dat er geen contact was.
          </p>
          <Link
            to="/onderzoek-en-onderbouwing"
            data-testid="home-onderzoek-link"
            className="lg:col-span-4 lg:justify-self-end inline-flex items-center gap-2 font-heading italic text-xl text-ll-ink hover:text-ll-coral transition-colors"
          >
            Lees alle onderzoeken en bronnen <ArrowUpRight size={18} />
          </Link>
        </div>
      </div>
    </section>
  );
}
